import React from 'react';

import './yoshiki-frame.scss';

export function YoshikiFrame() {
  return (
    <div className='yoshiki-frame'>
      <div className='yoshiki-frame--wrapper'>
        <iframe
          title='yoshiki frame'
          className='yoshiki-frame--iframe'
          frameBorder='0'
          scrolling='no'
          // @ts-ignore
          allowtransparency='true'
          src='https://cdn.yoshki.com/iframe/55845r.html'
        />
      </div>
    </div>
  );
}
